import { render, staticRenderFns } from "./EventosComponent.vue?vue&type=template&id=424b9e1c&scoped=true"
import script from "./EventosComponent.vue?vue&type=script&lang=js"
export * from "./EventosComponent.vue?vue&type=script&lang=js"
import style0 from "./EventosComponent.vue?vue&type=style&index=0&id=424b9e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b9e1c",
  null
  
)

export default component.exports